import {Component, Input, OnInit} from '@angular/core';
import {LocalStorageService} from "../../../../core/services/local-storage.service";

@Component({
	selector: 'app-moniepoint-balance-board',
	templateUrl: './moniepoint-balance-board.component.html',
	styleUrls: ['./moniepoint-balance-board.component.scss']
})
export class MoniepointBalanceBoardComponent implements OnInit {
	@Input() accountDetails: any;
	accountName: string;

	constructor(private localStorage: LocalStorageService) {
	}

	ngOnInit(): void {
		this.accountName = this.localStorage.get('name');
	}

}
